import styled from "styled-components/macro";

export const StyledFooter = styled.footer`
  background: #fbfbfb;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
  flex-wrap: wrap;
`;
